import { useState, useEffect } from "react";
import BlogCard from "../cards/BlogCard";
import urlSet from "../../utils/urls";
import { fetch as CFetch } from "../../utils/blogsHelper";
import axios from "axios";
import { Spinner } from "react-bootstrap";

const BlogGrid = ({ category }) => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [isCompleted, setCompleted] = useState(false);

  const getNextBlogs = async () => {
    try {
      const url =
        urlSet.get_blogApi.url +
        "?category=" +
        category +
        "&index=" +
        page * 6 +
        "&limit=" +
        6;
      setLoading(true);
      const res = await axios.get(encodeURI(url));
      if (page === 0) {
        setBlogs(res.data);
      } else {
        console.log(res.data);
        if (res.data.length > 0) {
          setBlogs([...blogs, ...res.data]);
        } else {
          setCompleted(true);
        }
      }

      setLoading(false);
      setPage((prev) => prev + 1);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    CFetch(
      urlSet.get_blogApi.url +
        "?minimal=true&index=0&limit=6" +
        "&category=" +
        category
    ).then((data) => {
      if (data) {
        setBlogs([...blogs, ...data]);
      }
    });
  }, []);

  return (
    <div>
      <h1 className="blogCategoryTitle fo-34 mt-5 fw-700">{category}</h1>
      <div className="row m-0 mt-3" id="displayAllBlogs">
        {blogs.map((blog, index) => (
          <BlogCard blog={blog} key={category + "_grid_" + index} />
        ))}
      </div>
      {loading && (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" />
        </div>
      )}
      <div className="text-center mt-5 mb-5">
        {isCompleted ? (
          <div className="fo-18 fw-600 text-center">
            <span>No more blogs</span>
          </div>
        ) : (
          <button className="btn showMoreButton" onClick={getNextBlogs}>
            Show More
          </button>
        )}
      </div>
    </div>
  );
};

export default BlogGrid;
